import React, { useContext, type ReactNode, type ComponentType } from 'react';
import { FieldsCompactModeContext } from '@atlassian/jira-issue-view-layout-templates-compact-mode-provider';
import { StyledFieldHeading } from './styled';

export {
	FieldHeadingTitle,
	FIELD_HEADING_TITLE_COMPONENT_SELECTOR,
	FieldHeadingIcons,
	FieldWrapper,
	FIELD_WRAPPER_COMPONENT_SELECTOR,
	SideBySideField,
	labelColumnWidthForGrouping as labelColumnWidth,
	BlankFieldHeading,
	MultilineFieldHeading,
	MultilineFieldHeadingTitle,
	MULTILINE_FIELD_HEADING_TITLE_COMPONENT_SELECTOR,
	DevPanelIconContainer,
	fieldHeadingSideBySideCss,
	FieldHeadingSideBySide,
	animationFadeIn,
	animationFadeOut,
	fieldHeadingIconsCss,
	FieldHeadingIconsVisibility,
	CustomFieldHeadingWithBottomMargin,
} from './styled';

type FieldHeadingProps = {
	fieldId?: string;
	children: ReactNode;
	onMouseEnter?: () => void;
	onMouseLeave?: () => void;
};

export const FieldHeading: ComponentType<FieldHeadingProps> = ({
	fieldId = 'field',
	children,
	...rest
}: FieldHeadingProps) => {
	const isCompact = useContext(FieldsCompactModeContext);

	return (
		<StyledFieldHeading
			data-testid={`issue-field-heading-styled-field-heading.${fieldId}`}
			isCompact={isCompact}
			{...rest}
		>
			{children}
		</StyledFieldHeading>
	);
};
